module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logintitle":"User Login","username":"User Name","password":"password","login":"Login"},"cn":{"logintitle":"用户登录","username":"用户名","password":"密码","login":"登录"}}')
  delete Component.options._Ctor
}
